import { generateUuid } from "../../utils/index";
import {
  defineComponent,
  PropType,
  ref,
  nextTick,
  watch,
  reactive,
  onMounted,
  onActivated,
} from "vue";
import CompanyTypeSelect from "@/components/company-type-select/index.vue";
import { CompanyPageRecord, CompanyPageReq } from "@/views/cooperation/company/company.interface";
import { CompanyService } from "@/views/cooperation/company/company.service";
import { CompanyContactService } from "@/views/cooperation/company/company-contact.service";
import { hmdConfirm } from "@/dialog/index";
import { bindEmitter } from "@/utils/emitter";
import { Form } from "ant-design-vue";
import { useRoute } from "vue-router";
export default defineComponent({
  isGlobal: true,
  name: "ContractCompanySelect",
  components: { CompanyTypeSelect },
  props: {
    // 公司ID
    value: { type: String, default: undefined },
    validate: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    typeAttributionList: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    sceneType: {//"场景类型：1-采购付款申请新增 2-分包付款申请新增 3-租赁付款申请新增"
      type: Number,
      default: undefined,
    },
  },
  emits: [
    "update:value",
    "update:valueName",
    "update:name",
    "update:nameId",
    "update:mobile",
    "change",
    "showModal",
    "clear",
    "changeValue",
  ],
  setup(props, { emit }) {
    const route = useRoute();
    const { data, run } = CompanyService.usePageApi();
    const { data: userList, run: runUserList } = CompanyContactService.useListApi();
    const isError = ref(false);
    const valueName = ref("");
    const queryRef = reactive(new CompanyPageReq());
    queryRef.enable = true;
    const formItemContext = Form.useInjectFormItemContext();
    bindEmitter("trigger-form-custom-validator", async () => {
      isError.value = false;
      if (props.validate) {
        if (!props.value) {
          isError.value = true;
          valueName.value = "";
          formItemContext.onFieldChange();
        } else {
          queryRef.current = 1;
          queryRef.size = 1;
          queryRef.cooperationCompanyId = props.value;
          await run(queryRef);
          //@ts-ignore
          valueName.value = data.value.find((o) => o.id == props.value)?.companyName as string;
          if (!valueName.value) {
            emit("update:value", undefined);
            emit("update:valueName", undefined);
          }
          if (props.value) {
            await runUserList(props.value);
            emit(
              "update:mobile",
              (userList.value as any).records[0]?.mobile ||
                (userList.value as any).records[0]?.landline
            );
            emit("update:name", (userList.value as any).records[0]?.name);
            emit("update:nameId", (userList.value as any).records[0]?.id);
          }
        }
      }
    });
    bindEmitter("trigger-keepalive-form-reset" + (route.name as string), () => {
      isError.value = false;
    });
    const errorEmitterKey = "contract-company-select-error" + generateUuid();
    bindEmitter(errorEmitterKey, (e) => {
      isError.value = e;
    });
    const companySelectValueNameKey = "contract-company-select-value-name" + generateUuid();
    bindEmitter(companySelectValueNameKey, (e) => {
      valueName.value = e;
      isError.value = false;
    });
    const companySelectCompanyIdKey = "contract-company-select-company-id" + generateUuid();
    bindEmitter(companySelectCompanyIdKey, (e) => {
      isError.value = false;
      emit("update:value", e);
      emit("update:valueName", valueName.value);
      nextTick(() => {
        formItemContext.onFieldChange();
      });
    });
    const removeSelected = () => {
      emit("update:value", null);
      emit("update:valueName", null);
      emit("change", null);
      emit("changeValue", null);

      emit("clear", null);
      emit("update:mobile", undefined);
      emit("update:name", undefined);
      emit("update:nameId", undefined);
      valueName.value = "";
      formItemContext.onFieldChange();
      isError.value = true;
    };
    const checkData = async (n, initial) => {
      isError.value = false;
      if (n) {
        queryRef.current = 1;
        queryRef.size = 1;
        queryRef.cooperationCompanyId = n;
        await run(queryRef);
        if (props.validate) {
          formItemContext.onFieldChange();
        }
        isError.value = false;
        //@ts-ignore
        valueName.value = data.value.find((o) => o.id == n)?.companyName as string;
        // // console.log(
        //   "data.value.find((o) => o.id == n)",
        //   data.value.find((o) => o.id == n)
        // );
        await runUserList(n);
        emit(
          "update:mobile",
          (userList.value as any).records[0]?.mobile || (userList.value as any).records[0]?.landline
        );
        emit("update:name", (userList.value as any).records[0]?.name);
        emit("update:nameId", (userList.value as any).records[0]?.id);
      } else {
        if (!initial) {
          if (props.validate) {
            valueName.value = "";
            isError.value = true;
            formItemContext.onFieldChange();
          } else {
            valueName.value = "";
            isError.value = false;
          }
        }
      }
    };
    watch(
      () => props.value,
      async (n, o) => {
        checkData(n, false);
      }
    );
    onMounted(async () => {
      checkData(props.value, true);
    });
    onActivated(async () => {
      checkData(props.value, true);
    });
    const showModal = () => {
      hmdConfirm({
        com: import("./dialog.vue"),
        params: {
          value: props.value,
          errorEmitterKey,
          companySelectValueNameKey,
          companySelectCompanyIdKey,
          typeAttributionList: props.typeAttributionList,
          sceneType: props.sceneType,
        },
        confirm: async ({ res }) => {
          await runUserList(res.id);

          // console.log("res", res, (userList.value as any).records);

          emit("update:value", res.id);
          emit("update:valueName", valueName.value);
          emit("update:name", res.name);
          emit("update:nameId", (userList.value as any).records[0]?.id);
          emit("update:mobile", res.mobile||res.landline);
          emit("change", res.id);
          emit("changeValue", res);
        },
      });
    };

    return {
      showModal,
      isError,
      valueName,
      removeSelected,
    };
  },
});
